export default "__VITE_ASSET__CsdBLM4e__"